import { BlockComponent, ID } from 'lib'
import { CardStyles } from 'experiences/dashboard/DashboardRoot/grid/GridElement'

export interface DashboardItem {
	key: string
	columns?: 1 | 2
	wrapperStyle?: CardStyles
	loadingContent?: JSX.Element
	Content: BlockComponent
}

export interface DashboardGroup {
	key: string
	items: Array<DashboardItem>
}

export const buildDashGroup = (item: DashboardItem): DashboardGroup => {
	return {
		key: ID(),
		items: [item]
	}
}

export const buildDashItem = (Content: JSX.Element, style: CardStyles = 'card', columns: 1 | 2 = 1): DashboardItem => {
	return { Content: () => Content, key: ID(), wrapperStyle: style, columns }
}
